/** F606 Ratings page — trainer / program ratings from users. */
import { Star } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606RatingsPage() {
  return (
    <F606DataPage
      entity="ratings"
      titleAr="التقييمات"
      titleEn="Ratings"
      icon={Star}
      emptyIcon={Star}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'target',
          ar: 'العنصر', en: 'Target',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.target_name || r.item_name || r.target_id || '—'}</div>
              {r.target_type && <div className="text-[10px] text-white/40">{r.target_type}</div>}
            </div>
          ),
        },
        { key: 'user_name', ar: 'المُقيِّم', en: 'By', render: (r) => r.user_name || '—' },
        {
          key: 'rating',
          ar: 'النجوم', en: 'Stars',
          render: (r) => {
            const n = Math.round(Number(r.rating || r.score || 0));
            return <span className="text-amber-300 font-mono">{'★'.repeat(n)}{'☆'.repeat(Math.max(0, 5 - n))}</span>;
          },
          className: 'w-28',
        },
        {
          key: 'comment',
          ar: 'التعليق', en: 'Comment',
          render: (r) => <span className="text-white/70 text-[11px] truncate max-w-sm block">{r.comment || r.review || '—'}</span>,
        },
        {
          key: 'created_at',
          ar: 'التاريخ', en: 'When',
          render: (r) => r.created_at ? new Date(r.created_at).toLocaleDateString() : '—',
          className: 'w-28 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
